import React from 'react';
import { PractitionerControlCardComponent } from '../../../components/Cards';

const PractitionerControlCard = () => <PractitionerControlCardComponent />;

export default PractitionerControlCard;
